"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canBeCborString = exports.forceCborString = void 0;
var bytestring_1 = require("@harmoniclabs/bytestring");
var CborString_1 = require("./CborString/index.js");
function forceCborString(cStr) {
    return new CborString_1.CborString(cStr instanceof bytestring_1.ByteString ? cStr.toBuffer() : cStr);
}
exports.forceCborString = forceCborString;
function canBeCborString(stuff) {
    return (typeof stuff === "string" ||
        stuff instanceof Uint8Array ||
        stuff instanceof bytestring_1.ByteString);
}
exports.canBeCborString = canBeCborString;
